<template>
  <OptimizedImage
    class="h-full w-full object-cover transition-transform duration-500 md:group-hover:scale-[1.04] md:group-hover:will-change-transform"
    loading="lazy"
    :alt="alt"
    :image-url="src"
    :optimized-image-options="{ width: 960 }"
  />
  <!-- 下端からの暗いグラデーション。Figma では下半分から #333→#000(60%) -->
  <div aria-hidden="true" class="pointer-events-none absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-b from-transparent to-black/60" />
</template>

<script lang="ts" setup>
import OptimizedImage from '@/wabunka-src/common/components/stateful/OptimizedImage/OptimizedImage.vue';

interface Props {
  src: string;
  alt: string;
}

defineProps<Props>();
</script>
